import { RectProps } from './svg';

export type UniformLayoutFn = (index: number) => RectProps;

export interface UniformLayout extends UniformLayoutFn {
  height: number;
  width: number;
  memberHeight: number;
  memberWidth: number;
}
